import React, { createContext, useContext } from 'react';

export interface AppConfig {
  auth0Domain: string;
  auth0ClientId: string;
  auth0Audience?: string;
  auth0RedirectPath?: string;
  allyApi: string;
}

const AppConfigContext = createContext<AppConfig | null>(null);

interface AppConfigProviderProps {
  value: AppConfig;
  children: React.ReactNode;
}

export const AppConfigProvider: React.FC<AppConfigProviderProps> = ({ value, children }) => (
  <AppConfigContext.Provider value={value}>{children}</AppConfigContext.Provider>
);

export const useAppConfig = (): AppConfig => {
  const contextValue = useContext(AppConfigContext);

  if (!contextValue) {
    throw new Error('useAppConfig must be used within AppConfigProvider');
  }

  return contextValue;
};
